(() => {
 if (customElements.get('sedy-hero-carousel')) return;
 class SedyHeroCarousel extends HTMLElement {
  connectedCallback() {
   this.slides = [...this.querySelectorAll('[data-slide]')];
   if (this.slides.length < 2) return;
   this.index = 0; this.hovered = false; this.inView = true;
   this.abort = new AbortController();
   const on = (node, name, fn, options = {}) => node.addEventListener(name, fn, {...options, signal: this.abort.signal});
   this.motion = matchMedia('(prefers-reduced-motion: reduce)');
   this.paused = this.dataset.autoplay !== 'true' || this.motion.matches || Boolean(window.Shopify?.designMode);
   this.dots = [...this.querySelectorAll('[data-dot]')];
   this.querySelector('.shc-controls').hidden = false;
   on(this.querySelector('[data-prev]'), 'click', () => this.show(this.index - 1, true));
   on(this.querySelector('[data-next]'), 'click', () => this.show(this.index + 1, true));
   this.dots.forEach((dot, i) => on(dot, 'click', () => this.show(i, true)));
   on(this.querySelector('[data-toggle]'), 'click', () => { this.paused = !this.paused; this.schedule(); });
   on(this, 'pointerenter', e => {if(e.pointerType === 'mouse'){this.hovered = true; this.schedule();}});
   on(this, 'pointerleave', e => {if(e.pointerType === 'mouse'){this.hovered = false; this.schedule();}});
   on(this, 'focusin', e => {if(e.target.closest('[data-toggle]')) return; this.paused = true; this.schedule();});
   on(this.querySelector('.shc-controls'), 'keydown', e => {
    if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {e.preventDefault(); this.show(this.index + (e.key === 'ArrowLeft' ? -1 : 1), true);}
   });
   on(document, 'visibilitychange', () => this.schedule());
   on(this.motion, 'change', () => {if (this.motion.matches) this.paused = true; this.schedule();});
   on(document, 'shopify:block:select', e => {
    const i = this.slides.findIndex(s => s.dataset.blockId === e.detail?.blockId);
    if (i >= 0) this.show(i, true);
   });
   const area = this.querySelector('.shc-slides');
   on(area, 'pointerdown', e => {if(e.pointerType === 'touch') this.touch = {x:e.clientX,y:e.clientY};}, {passive:true});
   on(area, 'pointercancel', () => {this.touch = null;}, {passive:true});
   on(area, 'pointerup', e => {
    if (!this.touch) return;
    const dx = e.clientX - this.touch.x, dy = e.clientY - this.touch.y; this.touch = null;
    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) {
     this.suppressClickUntil = performance.now() + 500; this.show(this.index + (dx < 0 ? 1 : -1), true);
    }
   }, {passive:true});
   on(area, 'click', e => {if(performance.now() < (this.suppressClickUntil || 0)){e.preventDefault(); e.stopPropagation();}}, {capture:true});
   this.observer = new IntersectionObserver(entries => {this.inView = entries[0].isIntersecting; this.schedule();}, {threshold:0.15});
   this.observer.observe(this); this.schedule(); this.warmNext(); this.dataset.ready = 'true';
  }
  show(index, manual = false) {
   this.index = (index + this.slides.length) % this.slides.length;
   this.slides.forEach((slide, i) => {slide.hidden = i !== this.index;});
   this.dots.forEach((dot, i) => {if (i === this.index) dot.setAttribute('aria-current','true'); else dot.removeAttribute('aria-current');});
   this.querySelector('[data-count]').textContent = `${this.index + 1} / ${this.slides.length}`;
   if (manual) {this.paused = true; this.querySelector('[data-status]').textContent = this.slides[this.index].getAttribute('aria-label');}
   this.schedule(); this.warmNext();
  }
  warmNext() {
   const current = this.slides[this.index].querySelector('img');
   const next = this.slides[(this.index + 1) % this.slides.length].querySelector('img');
   if (!current || !next) return;
   const warm = () => {next.loading = 'eager';};
   if (current.complete) warm(); else current.addEventListener('load', warm, {once:true, signal:this.abort.signal});
  }
  schedule() {
   clearTimeout(this.timer);
   this.querySelector('[data-toggle]').setAttribute('aria-label', this.paused ? 'Play slideshow' : 'Pause slideshow');
   this.querySelector('[data-toggle-text]').textContent = this.paused ? 'Play' : 'Pause';
   if (!this.paused && !this.hovered && this.inView && !document.hidden) this.timer = setTimeout(() => this.show(this.index + 1), Number(this.dataset.interval) || 7000);
  }
  disconnectedCallback() {clearTimeout(this.timer); this.abort?.abort(); this.observer?.disconnect();}
 }
 customElements.define('sedy-hero-carousel', SedyHeroCarousel);
})();
